import Button from "components/Button";
import Text from "components/Text";
import Tooltip from "components/Tooltip";

export interface IAIExtractionButton {
  text: string;
  disabled?: boolean;
  tooltipTitle?: string;
  onClick?: () => void;
  color?: "primary" | "secondary";
}

const AIExtractionButton = ({
  onClick,
  tooltipTitle,
  text,
  color = "primary",
  disabled = false,
}: IAIExtractionButton) => (
  <Tooltip title={tooltipTitle}>
    <span>
      <Button
        disabled={disabled}
        onClick={onClick}
        color={color}
        sx={{
          fontSize: 15,
          height: "24px",
        }}
      >
        <Text variant="text3" fontWeight={500} whiteSpace="nowrap">
          {text}
        </Text>
      </Button>
    </span>
  </Tooltip>
);

export default AIExtractionButton;
